import React, { Component } from 'react';

import api, { logout } from 'api';
import { Box, Text, Container, Logo, Button } from 'components';
import Addresses from './Addresses';
import Support from './Support';
import Updates from './Updates';
import Press from './Press';
import Summary from './Summary';
import Contributions from './Contributions';
import TermsModal from './TermsModal';

class Dashboard extends Component {
  state = {
    user: null,
    onboarding: null
  };

  componentDidMount() {
    api.get('users/me').then(res => {
      this.setState({ user: res.data });
    });
    api.get('onboarding').then(res => {
      this.setState({ onboarding: res.data });
    });
  }

  handleOnboarding = term => {
    this.setState({ onboarding: { ...this.state.onboarding, [term]: true } });
  };

  render() {
    const { user, onboarding } = this.state;

    if (!user || !onboarding) return null;

    // check if all onboarding modals have been accepted
    const onboarded = Object.keys(onboarding).every(k => {
      return onboarding[k];
    });

    if (!onboarded) {
      return <TermsModal onboarding={onboarding} handleOnboarding={this.handleOnboarding} />;
    }

    return (
      <Box className="color-primary">
        <Box py="3" shadow>
          <Container flex>
            <Logo text />
            <Box flex alignItems="center" ml="auto">
              <Box mr="4">
                <strong>
                  {user.first_name} {user.last_name}
                </strong>
              </Box>
              <Button onClick={logout} outline>
                Logout
              </Button>
            </Box>
          </Container>
        </Box>
        <Container py="5">
          <Text display="h1">Distribution Details</Text>
          <Box className="d-md-flex" justifyContent="between" py="4">
            <Summary user={user} />
            <Box flex="1" row flexWrap p="4" shadow>
              <Text display="h4">
                Congratulations! Your <br className="br-md" />
                Account is Confirmed 🎉
              </Text>
              <Text py="3">
                Token distribution is scheduled to take place in approximately 3-6 weeks unless further notified. Thank
                you for your continued patience as we work to confirm all participants.
              </Text>
              <Text py="3">
                We’ll keep you updated as the date draws closer. Feel free to contact us with any questions.
              </Text>
              <Box my="3">
                <a className="btn btn-secondary" href="mailto:ops@current.us">
                  Contact Us
                </a>
              </Box>
            </Box>
          </Box>
          <Box className="d-md-flex" justifyContent="between" py="4">
            <Support />
            <Addresses />
          </Box>
        </Container>
        <Container mb="5">
          <Contributions />
        </Container>
        <Box py="4" className="footer">
          <Container mt="4">
            <Press />
          </Container>
        </Box>
        <Box py="4" className="footer">
          <Container mt="4">
            <Updates />
          </Container>
        </Box>
      </Box>
    );
  }
}

export default Dashboard;
